import { defineComponent as n, createBlock as t, openBlock as a, withCtx as r, createCommentVNode as s, unref as o, createVNode as l } from "vue";
import { RevIllustration as m } from "@ds/components/Illustration";
import i from "../../../icons/generated/IconWarning.vue2.js";
import c from "./DocumentSmallAvatar.vue2.js";
import u from "./DocumentSmallBase.vue2.js";
const v = /* @__PURE__ */ n({
  name: "DocumentErrorSmall",
  __name: "DocumentErrorSmall",
  props: {
    name: {},
    url: {},
    errorMessage: {},
    thumbnail: { type: Boolean }
  },
  setup(f) {
    return (e, p) => (a(), t(u, {
      "button-attrs": {
        title: e.errorMessage,
        ...e.url && { href: e.url, target: "_blank" }
      },
      class: "border-static-danger-hi"
    }, {
      avatar: r(() => [
        l(c, {
          class: "pointer-events-none",
          interactive: !1,
          label: e.errorMessage
        }, {
          default: r(() => [
            l(o(i), {
              class: "text-static-danger-hi",
              size: "16"
            })
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      default: r(() => [
        e.url ? (a(), t(o(m), {
          key: 0,
          alt: "",
          height: 62,
          "image-class-names": "h-[calc(4rem-2px)] w-64 object-cover object-center",
          src: e.url,
          title: e.name,
          width: 64
        }, null, 8, ["src", "title"])) : s("", !0)
      ]),
      _: 1
    }, 8, ["button-attrs"]));
  }
});
export {
  v as default
};
